import { BasketItem, basketItemFromResponse } from './BasketItem';

export interface BasketSummary {
  items: BasketItem[];
  isBasketChange: boolean;
  freeShippingAmount?: number;
  canUsePointSystem: boolean;
  pointValue: number;
  pointMinValue: number;
  minPointUsageValue: number;
}

export const basketSummaryFromResponse = (
  responseData: any,
): BasketSummary => ({
  items: responseData.basket.map(basketItemFromResponse),
  isBasketChange: responseData.is_basket_change,
  freeShippingAmount: responseData.free_shipping_amount,
  canUsePointSystem: responseData.can_use_point_system,
  pointValue: responseData.point_value,
  pointMinValue: responseData.point_min_value,
  minPointUsageValue: responseData.min_point_usage_value,
});
